import React from "react";
import { steps } from "../data/content";
export function Method() {
  return <section id="metodo" className="mx-auto max-w-5xl px-6 py-16 sm:py-24" data-id="element-71" data-mp="72lqozod2yqh">
      <p className="mb-3 font-semibold text-accent" data-id="element-72" data-mp="74yehtgsw3bg">De la idea a una oferta lista para vender</p>
      <h2 className="mb-6 font-serif text-[30px] font-bold leading-tight sm:text-5xl" data-id="element-73" data-mp="bzvmcx2cg6mr">
        Un paso a la vez, con una dirección clara
      </h2>
      <ol className="grid gap-4 md:grid-cols-3" data-id="element-74" data-mp="3fjgldrv09cth">
        {steps.map((s, i) => <li key={s.title} className="rounded-xl border border-line bg-ink-3 p-6" data-id="element-75" data-mp="3kh8m9bdmo99t" data-mpi={i}>
            <p className="mb-3 text-2xl font-bold text-accent" data-id="element-76" data-mp="3pgv09n1a5tjo">{String(i + 1).padStart(2, "0")}</p>
            <h3 className="mb-2 font-semibold" data-id="element-77" data-mp="3u7l4uy1vtsdb">{s.title}</h3>
            <p className="leading-relaxed text-soft" data-id="element-78" data-mp="3u9624vfkzpev">{s.description}</p>
          </li>)}
      </ol>
    </section>;
}